export default __webpack_public_path__ + "static/media/marketplaceVolume.5c9e03f0.svg";